import type { ComponentProps } from "react"
import { X } from "lucide-react"
import { Toaster as Sonner } from "sonner"
import { useTheme } from "../../store/themeStore"

type ToasterProps = ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      closeButton
      richColors
      gap={12}
      offset={16}
      visibleToasts={4}
      expand={false}
      icons={{
        close: <X className="h-3.5 w-3.5" />,
      }}
      toastOptions={{
        closeButton: true,
      }}
      {...props}
    />
  )
}

export { Toaster }
